module.exports = __webpack_public_path__ + "img/1438162222.c393f73c.jpg";